import Api from 'api/api';
import { queryKeys } from 'api/queryKeys';

export const healthcareProviders = {
  queryKey: queryKeys.healthcareProviders,
  queryFn: Api.getHealthcareProviders,
};
